import React, { Fragment } from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Section/Contact'
import AboutSec from '../../component/Section/About'
import Head from '../../component/Section/Head'
import Number from '../../component/Section/Number'
import Step from '../../component/Section/Step'

const About = () => {
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <img src="./../images/Bg.png" className="images__wrap-head" alt="" />
                    <div className="wrapper__bg-head"></div>
                    <Navbar />
                    <Head default="" current="HER TEL İŞTE BIR ADIM ÖTESI!" title={"Hakkımızda"} />
                </div>

                <AboutSec />

                <Number />
                <Step />

                


                

                <Contact />

                <Footer />
            </div >
        </Fragment>
    )
}

export default About